export const defaultLocationSearch = {
  location: undefined,
  searchValue: '',
  searchValueTried: '',
};

export const ASSET_LOCATION_SEARCH_INDEX = 0;
export const LOCATION_SEARCHES = 'locationSearches';



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/constants.js